import {
    Card,
    Typography
} from "@mui/material";
import { getSubjectGroupCountsByFilterApi } from "api/meeting";
import { generateDecisionCountInfoPDFAPI } from "api/report";
import ReportFilterCountCard from "app/components/Card/report/ReportFilterCountCard";
import ReportDecisionCountInfoTable from "app/components/Table/reports/ReportDecisionCountInfoTable";
import { groupByPropertyName } from "app/utils/appHelpers";
import { useState } from "react";
import { useSelector } from "react-redux";

function ReportDecisionCountInfoPage({ }) {
    const [data, setData] = useState([]);
    const authUser = useSelector(state => state.auth.authUser);
    const [loading, setLoading] = useState(false);
    const setFilterData = (data) => {
        setData(data);
    };


    const handleResultList = async (state, setState, setLastFilter, setHasData, setLoading) => {
        setLoading(true);
        try {
            const filters = {
                inst: state.inst,
                unitId: state.unitId.map((unit) => unit.id),
                meetingNo: state.meetingNo,
                userId: authUser.id,
            };
            const res = await getSubjectGroupCountsByFilterApi(filters);
            setFilterData(res.data);
            setLastFilter(filters);
            setHasData(res.data && res.data.length > 0);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const generateDecisionCountInfoPDF = async (lastFilter, setLoading) => {
        if (!lastFilter) return;
        setLoading(true);
        try {
            await generateDecisionCountInfoPDFAPI(
                lastFilter.inst,
                lastFilter.unitId,
                lastFilter.meetingNo,
                lastFilter.userId
            );
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const groupedDataObj = groupByPropertyName(data, 'meetingId');
    const groupedData = Object.values(groupedDataObj).sort(
        (a, b) => b[0].meetingNo - a[0].meetingNo
    );
    return (
        <div>
            <ReportFilterCountCard
                loading={loading}
                setLoading={setLoading}
                title={"Kararların İstatistik Bilgileri"}
                setFilterData={setFilterData}
                onList={handleResultList}
                onGeneratePDF={generateDecisionCountInfoPDF}
            />




            {data.length > 0 ? (
                groupedData.map((group) => (
                    <Card key={group[0].meetingId} sx={{ padding: 2, marginBottom: 2 }}>
                        <ReportDecisionCountInfoTable data={group} />
                    </Card>
                ))
            ) : (

                !loading && (
                    <Card sx={{ padding: 2, marginTop: 2 }}>
                        <Typography align="center" variant="h6" sx={{ marginTop: 2 }}>
                            Sonuç Bulunamadı
                        </Typography>
                    </Card>
                )

            )}



        </div>
    );
}
export default ReportDecisionCountInfoPage;
